import { PropertiesOfStep } from '@components/Steps/Steps.utils';
import { StepsStep } from '@utils/enums/StepsStep.enum';

export enum OBEvents {
  apptSave = 'AppointmentTypePage_Save_Event',
  insSave = 'InsurancePage_Save_Event',
  apptChange = 'AppointmentTypeOrInsurance_Change_Event',
  schedCheck = 'ScheduleExam_Check_Event',
  shouldAutoContinue = 'ShouldAutoContinue_Check_Event',
}

export interface ISaveEvent {
  currentStep: StepsStep;
  propPage: PropertiesOfStep;
}
export interface IChangeEvent {
  type: string;
}

export interface IAutoContinueCheckEvent {
  shouldAutoContinue: boolean;
}

export interface ICheckEvent {
  patients: string[];
}
